import { combineReducers } from 'redux'
import accountReducer from './account/reducers'
import themeSlice from './theme/themeSlice'
import formReducer from './form/reducers'
import NotificationReducer from './notification/reducers'
import menuReducer from './menu/reducers'
import chatReducer from './chat/reducers'
import partnerReducer from './partner/reducers'

const rootReducers = combineReducers({
  theme: themeSlice,
  account: accountReducer,
  partner: partnerReducer,
  chat: chatReducer,
  menu: menuReducer,
  form: formReducer,
  notification: NotificationReducer,
})

export default rootReducers
